import { unreadNotifiesCount } from '@/api/commercial'
import { onMounted, ref } from 'vue'

/* 系统通知数量 */
const sysNoticeLogNumber = ref(0)
export const useSysHeaderNoticeNumber = () => {
  onMounted(async () => {
    await refresh()
  })

  const refresh = async () => {
    const { result: { data: { unread_total_notice } } } = await unreadNotifiesCount()
    sysNoticeLogNumber.value = unread_total_notice
  }

  return { sysNoticeLogNumber, refresh }
}

